import { UserDto } from "../../../common/services/application.do";
import { IAzUser } from "../../services/ms-graph.service";

export interface IUserTile {
  text: string;
  title: string;
  color: string;
  hidden: boolean;
}


export function getUserInitials(fullName: string): string {
  const names = fullName.split(' ').map(i => i.trim());
  const initials = names.filter(x => !!x).map(n => n.at(0).toUpperCase());
  return initials.join('');
}

export function getRandomColor(text: string): string {
  // Hash the string to a number
  let hash = 0;
  for (let i = 0; i < text.length; i++) {
    hash = text.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Convert the hash to RGB values
  const r = (hash & 0xFF0000) >> 16;
  const g = (hash & 0x00FF00) >> 8;
  const b = hash & 0x0000FF;

  // Generate a vibrant color while ensuring it's not too dark or too light
  const vibrantR = (r + 128) % 256;
  const vibrantG = (g + 128) % 256;
  const vibrantB = (b + 128) % 256;

  // Calculate brightness
  const brightness = (vibrantR * 299 + vibrantG * 587 + vibrantB * 114) / 1000;

  // Adjust the color to ensure it's suitable for white text
  let finalR = vibrantR;
  let finalG = vibrantG;
  let finalB = vibrantB;

  // If the color is too light, darken it
  if (brightness > 200) {
    const adjustmentFactor = 200 / brightness;
    finalR = Math.floor(finalR * adjustmentFactor);
    finalG = Math.floor(finalG * adjustmentFactor);
    finalB = Math.floor(finalB * adjustmentFactor);
  }

  // Ensure the color is not too dark
  const minBrightness = 100; // Minimum brightness threshold
  const finalBrightness = (finalR * 299 + finalG * 587 + finalB * 114) / 1000;
  if (finalBrightness < minBrightness) {
    const adjustmentFactor = minBrightness / finalBrightness;
    finalR = Math.floor(finalR * adjustmentFactor);
    finalG = Math.floor(finalG * adjustmentFactor);
    finalB = Math.floor(finalB * adjustmentFactor);
  }

  // Return the color in hex format
  return `#${((1 << 24) + (finalR << 16) + (finalG << 8) + finalB).toString(16).slice(1)}`;
}

export function getUserTile(user: UserDto | IAzUser): IUserTile {
  return {
    text: getUserInitials(user.displayName),
    color: getRandomColor(user.displayName),
    title: user.userPrincipalName,
    hidden: false
  };
}
